import { type KeycloakProfile } from 'keycloak-js'
import { getFirstCapitalLetter } from '@dhl/utils'

export const getProfileInitials = (result: KeycloakProfile) =>
  `${getFirstCapitalLetter(result.firstName || '')}${getFirstCapitalLetter(result.lastName || '')}`
